import React from "react";
import projects from "../../data/projects";
import ProjectCard from "./ProjectCard";

const SectionHeader = ({ tag, title, count }) => (
  <div className="grid grid-cols-12 gap-6 pt-24 md:pt-32 pb-6 border-b border-lab-rule-strong">
    <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
      <div>{tag}</div>
    </div>
    <div className="col-span-8 md:col-span-8">
      <h2 className="font-display text-3xl md:text-5xl font-semibold tracking-tightest text-lab-paper leading-none">
        {title}
      </h2>
    </div>
    <div className="col-span-4 md:col-span-2 text-right font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
      <div>Count</div>
      <div className="text-lab-paper tabular-nums">{String(count).padStart(2, "0")}</div>
    </div>
  </div>
);

const ProjectsSection = () => {
  const designed = projects.designed;
  const built = projects.built;

  return (
    <section className="relative bg-lab-ink text-lab-paper border-t border-lab-rule">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24">
        <SectionHeader tag="§ 02" title="Designed in-house." count={designed.length} />
        <div>
          {designed.map((p, i) => (
            <ProjectCard key={p.id} project={p} index={i + 1} section="DESIGNED" />
          ))}
        </div>

        <SectionHeader tag="§ 03" title="Assembled and calibrated." count={built.length} />
        <div>
          {built.map((p, i) => (
            <ProjectCard key={p.id} project={p} index={i + 1} section="BUILT" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
